import { render, staticRenderFns } from "./ech-side-menu.vue?vue&type=template&id=39beabeb&"
import script from "./ech-side-menu.vue?vue&type=script&lang=js&"
export * from "./ech-side-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ech-side-menu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports